export default {
  files: [
    {
      id: 'main',
      name: 'main file'
    },
    {
      id: 'risks',
      name: 'risk types',
      columns: ['id', 'type', 'definition', 'function']
    },
    {
      id: 'policies',
      name: 'policies',
      columns: ['name', 'owner', 'reviewed']
    },
    {
      id: 'procedures',
      name: 'procedures',
      columns: ['name', 'owner', 'reviewed']
    }
  ]
}
